<template>
  <div class="p-mb-3">
    <div class="search-bar" style="float: right">
      <i class="pi pi-search" />
      <InputText v-model="filters['global'].value" :placeholder="$t('factory.users.search')" style="width:70px" @update:modelValue="freeSearch" :aria-label="$t('factory.users.search')"/>
      <i class="pi pi-times" @click="() => {filters['global'].value=null; freeSearch();}"/>
    </div>
    <div class="p-formgroup-inline p-ai-center">
      <div v-if="serialNumber" class="p-field">
        <span class="admin-user-email">{{serialNumber}}</span>
      </div>
      <div class="p-field">
        <Dropdown id="role" v-model="filters['role'].value" :options="roles" optionLabel="name" optionValue="code"
          :placeholder="$t('factory.users.filter_role_ph')" @change="changeFilters" />
      </div>
      <div class="p-field">
        <Dropdown id="country" v-model="filters['country'].value" :options="countries" optionLabel="name" optionValue="code"
          :placeholder="$t('factory.users.filter_country_ph')" @change="changeFilters" 
          filter />
      </div>
    </div>

    <div v-if="serialNumber!=null && (userRole.includes('FACTORY') || userRole === 'SUBSIDIARY')" class="display-when-breakpoint">
      <span class="button-header" @click="shareDialog()"><i class="pi pi-plus" /> {{$t('factory.users.col_add')}}</span>
    </div>

    <DataTable :value="users" stripedRows 
      v-model:filters="filters" responsiveLayout="stack" 
      breakpoint="960px" :selectionMode="selectionMode" dataKey="email" @rowSelect="onRowSelect" 
      :autoLayout="true" sortField="email" :sortOrder="1" 
      :paginator="true" paginatorPosition="bottom" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" 
      v-model:first="table.first" :rows="table.rows" :totalRecords="table.totalRecords" :lazy="true"
      @update:first="reloadUsers"  
      :currentPageReportTemplate="'{totalRecords} ' + $t('factory.users.counter')">
      <template #empty>
          {{$t('factory.users.empty_list')}}
      </template>

      <Column field="email" :header="$t('factory.users.col_email')" ></Column>
      <Column field="companyName" :header="$t('factory.users.col_company')" ></Column>
      <Column field="country" :header="$t('factory.users.col_country')" >
        <template #body="slotProps">
          <span>{{getCountryName(slotProps.data.country)}}</span>
        </template>
      </Column>
      <Column field="role" :header="$t('factory.users.col_role')" >
        <template #body="slotProps">
          <span>
            {{ $t('roles.' + (serialNumber!=null && slotProps.data.role==='USER' ? slotProps.data.roleAppliance : slotProps.data.role)) }}
            {{ slotProps.data.role === 'SUBSIDIARY' ? ' ('+slotProps.data.domain+')' : '' }}
          </span>
        </template>
      </Column>

      <Column bodyClass="" class="irinox-table-buttons p-text-right">
        <template #header>
          <span class="sr-only">{{$t('common.actions')}}</span>
          <span v-if="(userRole.includes('FACTORY') || userRole === 'SUBSIDIARY') && serialNumber!=null" class="button-header" @click="shareDialog()">
            <i class="pi pi-plus" /> {{$t('factory.users.col_add')}}
          </span>
        </template>
        <template #body="slotProps">
          <div class="button-body">

            <img v-if="$config.afterSalesEnabled() && serialNumber==null && ((slotProps.data.role.includes('SERVICE') || (slotProps.data.role.includes('INTERNAL') && slotProps.data.role!=='INTERNAL_DOC') || slotProps.data.role==='SUBSIDIARY') && (userRole==='SUPERFACTORY' || userRole==='INTERNAL_DOC'))" 
                src="assets/irinox/icons/afterSales_visibility.svg" @click="docVisibility(slotProps.data)" v-tooltip.left="$t('factory.users.tooltip_docVisibility')" :alt="$t('factory.users.tooltip_docVisibility')"/>

            <i v-if="((userRole.includes('FACTORY') || userRole=='INTERNAL_DOC') && serialNumber==null && (slotProps.data.role!=='OPERATOR' && !slotProps.data.role.includes('FACTORY')))"  class="pi pi-crown"  v-tooltip.left="$t('factory.users.tooltip_advancedFeatures')"
              style="font-size: 16px; color: #9D9D9C; border: 1px solid #9D9D9C; border-radius: 10px; padding: 5px; margin-right: 5px;"
              :class="[
                {'features-seller-chatbot': slotProps.data.chatbot && slotProps.data.seller},
                {'features-seller': slotProps.data.seller && !slotProps.data.chatbot},
                {'features-chatbot': slotProps.data.chatbot && !slotProps.data.seller},
                ]"
              @click="() => {advFeaturesUser = slotProps.data; dialog.advFeatures = true;}" />

            <img v-if="userRole.includes('FACTORY') && serialNumber==null && (slotProps.data.role==='USER' || slotProps.data.role.includes('SERVICE'))" 
                src="assets/irinox/icons/promote.svg" @click="switchOp($event, slotProps.data.email)" v-tooltip.left="$t('factory.users.tooltip_promote')" :alt="$t('factory.users.tooltip_promote')"/>

            <img v-if="(userRole.includes('FACTORY') || userRole === 'SUBSIDIARY') && serialNumber==null && (slotProps.data.role==='USER' || slotProps.data.role.includes('SERVICE'))" 
                src="assets/irinox/icons/share.svg" @click="shareDialog(slotProps.data.email, slotProps.data.role)" v-tooltip.left="$t('factory.users.tooltip_share')" :alt="$t('factory.users.tooltip_share')"/>

            <img v-if="userRole.includes('FACTORY') && serialNumber!=null && slotProps.data.role==='USER'" 
                src="assets/irinox/icons/promote.svg" @click="promoteOp($event, slotProps.data.email)" v-tooltip.left="$t('factory.users.tooltip_promote')" :alt="$t('factory.users.tooltip_promote')"/>

            <img v-if="(userRole.includes('FACTORY') || userRole === 'SUBSIDIARY') && serialNumber!=null && (slotProps.data.role==='USER' || slotProps.data.role.includes('SERVICE'))" 
                src="assets/irinox/icons/unshare.svg" @click="unshareDialog(slotProps.data.email)" v-tooltip.left="$t('factory.users.tooltip_unshare')" :alt="$t('factory.users.tooltip_unshare')"/>

            <img v-if="userRole.includes('FACTORY') && (slotProps.data.role==='USER' || slotProps.data.role.includes('SERVICE'))" 
                src="assets/irinox/icons/delete.svg" @click="deleteDialog(slotProps.data.email)" v-tooltip.left="$t('factory.users.tooltip_delete')" :alt="$t('factory.users.tooltip_delete')"/>

          </div>
        </template>
      </Column>
    </DataTable>

    <OverlayPanel ref="op" class="download-op" style="width: 200px">
      <div @click="promoteDialog($event, 'ADMIN')">{{$t('roles.ADMIN')}}</div>
      <div @click="promoteDialog($event, 'KITCHEN_MANAGER')">{{$t('roles.KITCHEN_MANAGER')}}</div>
    </OverlayPanel>

    <OverlayPanel ref="switch" class="download-op" style="width: 180px">
      <div @click="switchDialog($event, 'USER')">{{$t('roles.USER')}}</div>
      <div @click="switchDialog($event, 'SERVICE')">{{$t('roles.SERVICE')}}</div>
      <div @click="switchDialog($event, 'SERVICE_SALES')">{{$t('roles.SERVICE_SALES')}}</div>
    </OverlayPanel>

  </div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('factory.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

  <!--         -->
  <!-- PROMOTE -->
  <!--         -->
  <IrinoxDialogDark :visible="dialog.promote" mode="confirm" 
    :leftB="$t('factory.promote_dialog_cancel_button')" @click:left-button="()=>{dialog.promote=!dialog.promote}" 
    :rightB="$t('factory.promote_dialog_ok_button')" @click:right-button="promote" 
    :message="dialog.promoteText"
    icon="assets/irinox/icons/promote_big.svg" />
  <IrinoxDialogDark :visible="dialog.promoteSuccess" 
    mode="success" 
    :message="$t('factory.promote_dialog_success')"
    :life="3000" 
    @update:visible="dialog.promoteSuccess = $event" />

  <!--         -->
  <!-- SWITCH  -->
  <!--         -->
  <IrinoxDialogDark :visible="dialog.switch" mode="confirm" 
    :leftB="$t('factory.switch_dialog_cancel_button')" @click:left-button="()=>{dialog.switch=!dialog.switch}" 
    :rightB="$t('factory.switch_dialog_ok_button')" @click:right-button="switchRole" 
    :message="dialog.switchText"
    icon="assets/irinox/icons/promote_big.svg" />
  <IrinoxDialogDark :visible="dialog.switchSuccess" 
    mode="success" 
    :message="$t('factory.switch_dialog_success')"
    :life="3000" 
    @update:visible="dialog.switchSuccess = $event" />

  <!--         -->
  <!-- UNSHARE -->
  <!--         -->
  <IrinoxDialogDark :visible="dialog.unshare" mode="confirm" 
    :leftB="$t('factory.unshare_dialog_cancel_button')" @click:left-button="()=>{dialog.unshare=!dialog.unshare}" 
    :rightB="$t('factory.unshare_dialog_ok_button')" @click:right-button="unshare" 
    :message="$t('factory.unshare_dialog')"
    icon="assets/irinox/icons/unshare_big.svg" />
  <IrinoxDialogDark :visible="dialog.unshareSuccess" 
    mode="success" 
    :message="$t('factory.unshare_dialog_success')"
    :life="3000" 
    @update:visible="dialog.unshareSuccess = $event" />

  <!--        -->
  <!-- DELETE -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.delete" mode="confirm" 
    :leftB="$t('factory.users.delete_dialog_cancel_button')" @click:left-button="()=>{dialog.delete=!dialog.delete}" 
    :rightB="$t('factory.users.delete_dialog_ok_button')" @click:right-button="deleteUser" 
    :message="$t('factory.users.delete_dialog')"
    icon="assets/irinox/icons/delete_big.svg" />
  <IrinoxDialogDark :visible="dialog.deleteSuccess" 
    mode="success" 
    :message="$t('factory.users.delete_dialog_success')"
    :life="3000" 
    @update:visible="dialog.deleteSuccess = $event" />

  <!--              -->
  <!-- SHARE DIALOG -->
  <!--              -->
  <ShareAppliancesDialogFactory :visible="dialog.share" 
    :preselectedAppliances="selectedAppliances"
    @update:visible="closeShareDialog"
    @click:left-button="closeShareDialog" 
    @click:right-button="closeShareDialog"/>

  <!--              -->
  <!-- DOC VISIBILITY -->
  <!--              -->
  <DocVisibility :visible="dialog.visibility" 
    :email="item.email" :companyName="item.companyName"
    @update:visible="dialog.visibility = $event"/>

  <!--            -->
  <!-- ADD DIALOG -->
  <!--            -->
  <ShareDialog :visible="dialog.add" 
    mode="factory"
    :appliances="selectedAppliances"
    :email="item.email"
    :role="item.role"
    @update:visible="dialog.add = $event" 
    @click:button="addShare" 
    @click:open-share="openShareDialog"/>
  <IrinoxDialogDark :visible="dialog.addSuccess" 
    mode="success" 
    :message="$t('admin.users.add_dialog_success_edit')"
    :life="3000" 
    @update:visible="dialog.addSuccess = $event" />

  <!--              -->
  <!-- ADV FEATURES -->
  <!--              -->
  <AdvFeatures :visible="dialog.advFeatures" 
    :user="advFeaturesUser"
    @update:visible="dialog.advFeatures = $event; reloadUsers();"/>

</template>

<script>
import AccountService from '../../service/AccountService';
import ApplianceService from '../../service/ApplianceService';
import CountryService from '../../service/CountryService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import ShareDialog from '../ShareDialog.vue';
import ShareAppliancesDialogFactory from '../ShareAppliancesDialogFactory.vue';
import {FilterMatchMode} from 'primevue/api';
import { mapGetters } from 'vuex';
import DocVisibility from './DocVisibility.vue';
import AdvFeatures from './AdvFeatures.vue';

export default {
    components: {
        IrinoxDialogDark,
        ShareDialog,
        DocVisibility,
        ShareAppliancesDialogFactory,
        AdvFeatures
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          users: [],
          countryList: [],
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'role': {value: null, matchMode: FilterMatchMode.EQUALS},
              'country': {value: null, matchMode: FilterMatchMode.EQUALS}
          },
          roles: [{ 
              code: null,
              name: this.$t('factory.users.filter_remove') 
            }],
          countries: [{ 
              code: null,
              name: this.$t('factory.users.filter_remove') 
            }],
          item: {
            email: null,
            role: null,
            companyName: null,
          },
          selectedAppliances: [],
          dialog: {
            error: false,
            promote: false,
            promoteSuccess: false,
            promoteText: null,
            unshare: false,
            unshareSuccess: false,
            delete: false,
            deleteSuccess: false,
            share: false,
            add: false,
            addSuccess: false,
            switch: false,
            switchSuccess: false,
            switchText: null,
            visibility: false,
            advFeatures: false,
          },
          table: {
            rows: 50,
            totalRecords: 0,
            first: 0
          },
          freeSearchTimer: null,
          visibility: {},
          advFeaturesUser: null,
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          userRole: 'userdata/role',
          uxData: 'preferences/uxData',
        }),
        appliance: function() {
            return this.serialNumber ? this.$store.getters['appliances/appliance'](this.serialNumber) : null;
        },
        selectionMode: function() {
          return this.serialNumber!=null ? null : 'single';
        }
    },
    watch: {
      // 'filters': {
      //   handler: 'updateUxData',
      //   deep: true
      // }
    },
    created() {
      this.countryService = new CountryService();
      this.accountService = new AccountService();
      this.applianceService = new ApplianceService();
    },
    mounted() {
      if(!this.serialNumber) {
        this.$store.commit('preferences/addUxData', { "factory.tab": "users" });
        this.filters = {...this.filters, ...(this.$functions.clone(this.uxData["factory.users.filters"] ?? {}))};
        this.table.first = this.uxData["factory.users.paginationFirst"] ?? 0;
        this.roles = [{ 
                code: null,
                name: this.$t('factory.users.filter_remove') 
              },{ 
                code: "USER",
                name: this.$t('roles.USER')
              },{ 
                code: "INTERNAL",
                name: this.$t('roles.INTERNAL')
              },{ 
                code: "INTERNAL_SUB",
                name: this.$t('roles.INTERNAL_SUB')
              },{ 
                code: "FACTORY",
                name: this.$t('roles.FACTORY')
              },{ 
                code: "INTERNAL_DOC",
                name: this.$t('roles.INTERNAL_DOC')
              },{ 
                code: "SERVICE",
                name: this.$t('roles.SERVICE')
              },{ 
                code: "SERVICE_SALES",
                name: this.$t('roles.SERVICE_SALES')
              },{ 
                code: "SUBSIDIARY",
                name: this.$t('roles.SUBSIDIARY')
              },{ 
                code: "SUPERFACTORY",
                name: this.$t('roles.SUPERFACTORY')
              }]
      } else {
        this.roles = [{ 
                code: null,
                name: this.$t('factory.users.filter_remove') 
              // },{ 
              //   code: "ADMIN",
              //   name: this.$t('roles.ADMIN')
              // },{ 
              //   code: "KITCHEN_MANAGER",
              //   name: this.$t('roles.KITCHEN_MANAGER')
              },{ 
                code: "USER",
                name: this.$t('roles.USER')
              },{ 
                code: "SERVICE",
                name: this.$t('roles.SERVICE')
              }]
      }
      this.countryService.getCountries().then((countries) => {
          this.countryList = countries;
          this.countries = this.$functions.clone(countries);
          this.countries.unshift({ 
                code: null,
                name: this.$t('factory.users.filter_remove') 
              });
          this.reloadUsers();
      });
    },
    methods: {
      // updateUxData() {
      //   if(!this.serialNumber) {
      //     this.$store.commit('preferences/addUxData', {"factory.users.filters": this.$functions.clone(this.filters)} );
      //   }
      // },
      freeSearch() {
        clearTimeout(this.freeSearchTimer);
        this.freeSearchTimer = setTimeout(() => {
          this.changeFilters();
        }, 1000 );
      },
      changeFilters() {
        if(!this.serialNumber) {
          this.$store.commit('preferences/addUxData', {"factory.users.filters": this.$functions.clone(this.filters)} );
        }
        this.table.first = 0;
        this.reloadUsers();
      },
      reloadUsers() {
        this.accountService.getFactoryUsersFilter(this.personaltoken, this.serialNumber, this.filters, this.table)
          .then((data) => {
            if(data.code=='200') {
              this.table.totalRecords = data.body.count;
              this.users = data.body.items;
              // let rs = [];
              // let cs = [];
              // for(let i=0; i<this.users.length; i++) {
              //   if(this.serialNumber!=null && this.users[i].role==='USER') {
              //     rs.push({ code: this.users[i].roleAppliance, name: this.$t('roles.'+this.users[i].roleAppliance) });
              //   } else {
              //     rs.push({ code: this.users[i].role, name: this.$t('roles.'+this.users[i].role) });
              //   }
              //   if(this.users[i].country) {
              //     let country = this.countryList.find(obj => obj.code === this.users[i].country);
              //     cs.push({ code: this.users[i].country, name: country ? country.name : this.users[i].country });
              //   }
              // }
              // let emptyData = { 
              //   code: null,
              //   name: this.$t('factory.users.filter_remove') 
              // };
              // this.roles = this.$functions.uniqByKeepFirst(rs, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
              // this.countries = this.$functions.uniqByKeepFirst(cs, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
              // this.roles.unshift(emptyData);
              // this.countries.unshift(emptyData);

            } else {
              console.error("EXCEPTION "+data);
              this.users = [];
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.users = [];
            this.dialog.error = true;
          });
      },
      getCountryName(code) {
        let country = this.countryList.find(obj => obj.code === code);
        if(country && country.name) {
          return country.name;
        }
        return code;
      },
      promoteOp(event, email) {
        this.item.email = email;
        this.$refs.op.toggle(event);
      },
      promoteDialog(event, role) {
        this.$refs.op.toggle(event);
        this.item.role = role;
        this.dialog.promoteText = this.$t('factory.promote_dialog').replace("[email]",this.item.email).replace("[role]",this.$t('roles.'+role));
        this.dialog.promote = true;
      },
      promote() {
        let shareData = {
          email: this.item.email,
          role: this.item.role,
          appliances: [this.serialNumber]
        };

        this.dialog.promote = false;
        this.applianceService.postFactoryShare(this.personaltoken, shareData)
          .then(() => {
            this.dialog.promoteSuccess = true;
            setTimeout(function() {
              this.reloadUsers();
            }.bind(this),3000);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });

      },
      unshareDialog(email) {
        this.item.email = email;
        this.dialog.unshare = true;
      },
      unshare() {
        this.dialog.unshare = false;
        this.applianceService.deleteFactoryShare(this.personaltoken, this.item.email, this.serialNumber)
          .then(() => {
            this.dialog.unshareSuccess = true;
            setTimeout(function() {
              this.reloadUsers();
            }.bind(this),3000);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      deleteDialog(email) {
        this.item.email = email;
        this.dialog.delete = true;
      },
      deleteUser() {
        this.dialog.delete = false;
        this.accountService.deleteUser(this.personaltoken, this.item.email)
          .then(() => {
            this.dialog.deleteSuccess = true;
            setTimeout(function() {
              this.reloadUsers();
            }.bind(this),3000);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },  
      shareDialog(email, role) {
        this.selectedAppliances = this.serialNumber ? [this.appliance] : [];
        this.item.email = email;
        this.item.role = role;
        this.dialog.add = true;
      },
      openShareDialog() {
        this.dialog.add = false;
        this.dialog.share = true;
      },
      closeShareDialog(appliances) {
        if(appliances) {
          this.selectedAppliances = appliances;
        }
        this.dialog.share = false;
        this.dialog.add = true;
      },
      addShare(shareData) {

        shareData.appliances = [];
        for (let i = 0; i < this.selectedAppliances.length; i++) {
          shareData.appliances.push(this.selectedAppliances[i].serialNumber);
        }

        this.dialog.add = false;

        this.applianceService.postFactoryShare(this.personaltoken, shareData)
          .then(() => {
            this.dialog.addSuccess = true;
            this.reloadUsers();
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      onRowSelect(event) {
        if(event.originalEvent.target.className == "button-body" ||
            event.originalEvent.target.parentNode.className == "button-body" ||
            this.serialNumber!=null) {
          //SKIP ROW CLICK IF LAST COLUMN
          event.originalEvent.preventDefault();
          return;
        }
        this.$router.push({ name: 'factory-user', params: { encryptedEmailRole: this.$functions.crypt("factory", event.data.email+"|||"+event.data.role) } });
      },
      switchOp(event, email) {
        this.$refs.switch.toggle(event);
        this.item.email = email;
      },
      switchDialog(event, role) {
        this.$refs.switch.toggle(event);
        this.item.role = role;
        this.dialog.switchText = this.$t('factory.switch_dialog').replace("[email]",this.item.email).replace("[role]","<strong>"+this.$t('roles.'+this.item.role)+"</strong>");
        if(role.includes('SERVICE')) {
          this.dialog.switchText += (" " + this.$t('factory.switch_dialog_disclaimer'));
        }
        this.dialog.switch = true;
      },
      switchRole() {
        this.dialog.switch = false;
        this.accountService.upgradeUser(this.personaltoken, this.item.email, this.item.role)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.switchSuccess = true;
              this.reloadUsers();
            } else {
              console.error("EXCEPTION "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      docVisibility(data) {
        this.item.email = data.email;
        this.item.companyName = data.companyName;
        this.item.role = data.role;
        this.dialog.visibility = true;
      }
    }
}
</script>

<style scoped>

.irinox-form .p-dropdown {
  width: 200px;
}

</style>

<style>


</style>